// extracted by mini-css-extract-plugin
module.exports = {"legend":"_80ad21f8ef--legend--37VFi"};